import React from 'react';

export default class Frown extends React.PureComponent {
  render() {
    const radius = this.props.canvasSize / 2;
    return (
      <g fill="none">
        <circle className="fill-current" cx={radius} cy={radius} r={radius} />
        <path
          d="M26.41 17.863c.374.913.59 1.987.59 3.137 0 3.314-1.79 6-4 6s-4-2.686-4-6c0-1.384.312-2.658.837-3.673 2.09.242 4.29.423 6.573.536zm17.753-.536c.525 1.015.837 2.29.837 3.673 0 3.314-1.79 6-4 6s-4-2.686-4-6c0-1.15.216-2.224.59-3.137 2.283-.113 4.484-.294 6.573-.536z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
        <path
          d="M17 47c2.467-5.275 8.477-9 15.5-9s13.033 3.725 15.5 9c-3.861-2.822-9.376-4.589-15.5-4.589-6.124 0-11.639 1.767-15.5 4.589z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
      </g>
    );
  }
}
